//
//
//
//
//
//
//
//
//
//
//
//

import Content from './Content.vue'

export default {
  components: { Content },
  props: {
    gridContent: {
      type: Array,
      required: true
    },
    minContentWidth: {
      type: Number,
      required: true
    },
    gridGap: {
      type: Number,
      required: true
    },
    minColumns: {
      type: Number,
      required: true
    },
    maxColumns: {
      type: Number,
      required: true
    },
    contentIsSpacedEvenly: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    gridStyle() {
      return {
        display: 'grid',
        gap: `${this.gridGap}px`,
        'grid-template-columns': `repeat(auto-fit, minmax(min((100%/${this.minColumns} - ${this.gridGap}px*(${this.minColumns} - 1)/${this.minColumns}), max(${this.minContentWidth}px, (100%/${this.maxColumns} - ${this.gridGap}px*(${this.maxColumns} - 1)/${this.maxColumns}))), 1fr))`
      }
    }
  }
}
